module.exports = __webpack_public_path__ + "img/kuaijin.7ec7de03.png";